import { useSelectedLanguageName } from '@/hooks/useSelectedLanguageName'
import ContinueButton from '@app-studio-web/ui/components/ContinueButton'
import { useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'
import QuizLayout from './QuizLayout'

const TITLE = 'pages.quizOnboarding.comparison.title'

const TRADITIONAL_ROWS = [
  'pages.quizOnboarding.comparison.traditional1',
  'pages.quizOnboarding.comparison.traditional2',
]

const LINGO_ROWS = [
  'pages.quizOnboarding.comparison.lingo1',
  'pages.quizOnboarding.comparison.lingo2',
  'pages.quizOnboarding.comparison.lingo3',
]

function CheckIcon() {
  return (
    <span className="bg-primary flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-white">
      <svg width="12" height="12" viewBox="0 0 20 20" fill="none">
        <path
          d="M5 10.5l3.5 3.5L15 6"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}

function CrossIcon() {
  return (
    <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#e2e8f0] text-[#94a3b8]">
      <svg width="10" height="10" viewBox="0 0 20 20" fill="none">
        <path
          d="M6 6l8 8M14 6l-8 8"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      </svg>
    </span>
  )
}

export default function ComparisonPage() {
  const { t } = useTranslation()
  const language = useSelectedLanguageName()

  return (
    <QuizLayout>
      <div className="flex grow flex-col justify-center gap-8">
        <div className="space-y-3 text-center">
          <h1 className="text-custom-black text-2xl font-extrabold text-balance md:text-3xl">
            {t(TITLE, { language })}
          </h1>
          <p className="mx-auto max-w-md text-[15px] leading-relaxed text-[#4a5568]">
            {t('pages.quizOnboarding.comparison.subtitle')}
          </p>
        </div>

        <div className="mx-auto grid w-full max-w-md grid-cols-2 gap-4">
          <div className="rounded-3xl border border-[#e2e8f0] bg-white p-5">
            <p className="mb-4 text-center text-sm font-bold text-[#94a3b8]">
              {t('pages.quizOnboarding.comparison.traditionalHeading')}
            </p>
            <ul className="space-y-3">
              {TRADITIONAL_ROWS.map((rowKey) => (
                <li key={rowKey} className="flex items-start gap-2">
                  <CrossIcon />
                  <span className="text-sm text-[#4a5568]">{t(rowKey)}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="border-primary rounded-3xl border-2 bg-white p-5 shadow-sm">
            <p className="text-primary mb-4 text-center text-sm font-bold">
              {t('pages.quizOnboarding.comparison.lingoHeading')}
            </p>
            <ul className="space-y-3">
              {LINGO_ROWS.map((rowKey) => (
                <li key={rowKey} className="flex items-start gap-2">
                  <CheckIcon />
                  <span className="text-custom-black text-sm font-medium">
                    {t(rowKey)}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <Form className="shrink-0" method="post">
        <input
          name={t(TITLE, { lng: 'en', language })}
          type="hidden"
          value={t('shared.continue', { lng: 'en' })}
        />

        <ContinueButton />
      </Form>
    </QuizLayout>
  )
}
